<script setup lang="ts">
const dm = useDM()
</script>

<template>
  <ClientOnly>
    <div v-if="dm" class="dm-only">
      <slot />
    </div>
  </ClientOnly>
</template>

<style scoped></style>
